import containerFuild from '../html-snippets/container-fuild.js';
import dividerPrimary from '../../../views/website/products/components/description/ui-modules/divider-primary/raw-html.js';
import css from '../css-snippets/fastvaluedeal-card-step';

const dividerPrimaryHtml = dividerPrimary({
  show: true,
  maxWidth: 90,
  height: 6,
  align: 'center',
  backgroundColor: '#5B04DE',
});

const stepItemHtml = ({
  number = '01',
  stepImageSrc = '',
  contentIconSrc = '',
  contentTitle = '',
  contentDescription = '',
}) => `
<div
  class="fvd-card-step__item"
  data-attribute="fvd-card-step__item"
>
  <div class="fvd-card-step__item-media" data-attribute="fvd-card-step__item-media">
    <span
      class="fvd-card-step__step-number"
      data-attribute="fvd-card-step__step-number"
    >${number}</span>
    <img
      data-attribute="fvd-card-step__step-image"
      src="${stepImageSrc}"
      alt="step"
    />
  </div>
  <div class="fvd-card-step__item-content" data-attribute="fvd-card-step__item-content">
    <div class="fvd-card-step__content-head">
      <img
        data-attribute="fvd-card-step__content-icon"
        class="fvd-card-step__content-icon"
        src="${contentIconSrc}"
        alt="icon"
      />
      <div data-attribute="fvd-card-step__content-title" class="fvd-card-step__content-title">
        ${contentTitle}
      </div>
    </div>
    <div data-attribute="fvd-card-step__content-description" class="fvd-card-step__content-description">
      ${contentDescription}
    </div>
  </div>
</div>`;

const html = `
<div
  class="fvd-card-step-content container"
  data-attribute="fvd-card-step-content"
>
  <div data-attribute="fvd-card-step__header" class="fvd-card-step__header">
    <div data-attribute="fvd-card-step__title" class="fvd-card-step__title">
      <h2 style="text-align: center"><strong>Enjoy Free HDTV In 3 Easy Steps</strong></h2>
    </div>
    ${dividerPrimaryHtml}
    <div data-attribute="fvd-card-step__description" class="fvd-card-step__description">
      <p style="text-align:center;">
        <span style="color:hsl( 0, 1%, 46% );">
          Don't worry about complex setups and tangled wires. WaveMax is designed to be so simple to set up, that it will only take you a minute.
        </span>
      </p>
    </div>
  </div>
  <div
    class="fvd-card-step__grid"
    data-attribute="fvd-card-step__grid"
    data-columns="3"
    data-gap="20"
    data-step-number-bg="#ffffff"
    data-step-number-color="#0130E2"
    style="--columns: 3; --gap: 20px; --step-number-bg: #ffffff; --step-number-color: #0130E2;"
  >
    ${stepItemHtml({
      number: '01',
      contentTitle: '<p><strong>Connect To TV Coaxial</strong></p>',
      contentDescription:
        '<p><span style="color:hsl( 0, 1%, 46% );">Using the provided cable, connect the device to your television set.</span></p>',
      stepImageSrc: 'https://cdn.skyfastimg.com/images/2026/06/04/image-6a211e953ae0a76b18783692.jpg',
      contentIconSrc: 'https://cdn.skyfastimg.com/images/2026/06/04/image-6a211eaa3280cbb93c683c93.png',
    })}
    ${stepItemHtml({
      number: '02',
      contentTitle: '<p><strong>Sync With Your TV</strong></p>',
      contentDescription:
        '<p><span style="color:hsl( 0, 1%, 46% );">Select WaveMax as the main broadcast source on your TV.</span></p>',
      stepImageSrc: 'https://cdn.skyfastimg.com/images/2026/06/04/image-6a211ed1280b487c388fd9e2.jpg',
      contentIconSrc: 'https://cdn.skyfastimg.com/images/2026/06/04/image-6a211eeb610bdb7f40b67837.png',
    })}
    ${stepItemHtml({
      number: '03',
      contentTitle: '<p><strong>Sit Back And Enjoy!</strong></p>',
      contentDescription:
        '<p><span style="color:hsl( 0, 1%, 46% );">That\'s it! Now you have endless entertainment at your fingertips.</span></p>',
      stepImageSrc: 'https://cdn.skyfastimg.com/images/2026/06/04/image-6a211edb3c00aa7cc7c3a612.jpg',
      contentIconSrc: 'https://cdn.skyfastimg.com/images/2026/06/04/image-6a211ef795c05cc42ee5a775.png',
    })}
  </div>
</div>
`;

export default containerFuild(html, css, {
  backgroundColor: '#FFFFFF',
});
